import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [{
        path: '/lucky',
        name: '抽奖',
        component: () => import('./pages/lucky/Index.vue'),
        children: [{
            path: '/lucky/turntable',
            name: '双11幸运转盘',
            component: () => import('./pages/lucky/Turntable.vue'),
        }, {
            path: '/lucky/test',
            name: '双11幸运转盘',
            component: () => import('./pages/lucky/Test.vue'),
        }]
    }]
})